// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from 'react' // eslint-disable-line import/no-extraneous-dependencies
// import PropTypes from 'prop-types'
import { css } from 'glamor'

import pickBy from 'lodash/pickBy'
import startsWith from 'lodash/startsWith'
import values from 'lodash/values'
import map from 'lodash/map'
import isUndefined from 'lodash/isUndefined'

// ----------------------------------- Components
import MediaQuery from 'react-responsive'
import Gallery from 'react-photo-gallery'

import keygen from '../../methods/keygen'
import NewInteractiveImage from './NewInteractiveImage'

/**
 * [description]
 * @return {[type]} [description]
 */
const mobileViewerClass = ({ numberOfPhotos }) =>
  css({
    '&.mobile-viewer': {
      overflowX: 'scroll',
      padding: 12,
      background: '#f2f2f2',

      '& .gallery-container': {
        width: `${numberOfPhotos * 0.5 * 100}%`,
      },
    },
  }).toString()

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
 * [description]
 * @param  {[type]}    options.photos         [description]
 * @param  {[type]}    options.columns        [description]
 * @param  {[type]}    options.loader         [description]
 * @param  {[type]}    options.gradientPreset [description]
 * @param  {...[type]} options.props          [description]
 * @return {[type]}                           [description]
 */
/** InteractiveImages */
class InteractiveImages extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props)
  }

  /**
   * [shouldComponentUpdate description]
   * @param  {[type]} nextProps [description]
   * @param  {[type]} nextState [description]
   * @return {[type]}           [description]
   */
  shouldComponentUpdate(nextProps, nextState) {
    return false
  }

  /** standard renderer */
  render() {
    const {
      data,
      lookup = 'image',
      columns = { min: 3, max: 3 },
      imageWidth = 600,
      setActive,
      mobileViewer = true,
    } = this.props
    const temp = values(pickBy(data, (value, key) => startsWith(key, lookup)))
    const photos = []
    map(temp, (d, i) =>
      photos.push({
        ...d,
        src: d.childImageSharp.fluid.src,
        index: i,
        width: imageWidth,
        height: Math.round(imageWidth / d.childImageSharp.fluid.aspectRatio),
      })
    )
    const numberOfPhotos = photos.length

    /** InteractiveImageX */
    const InteractiveImageX = ({ photo, margin }) => {
      return (
        <NewInteractiveImage
          data={photo}
          style={{ width: photo.width, height: photo.height, margin }}
          heading={
            !isUndefined(photo.heading) && (
              <h3 style={{ color: '#fff' }}>{photo.heading}</h3>
            )
          }
          text={
            !isUndefined(photo.text) && (
              <p style={{ color: '#fff' }}>{photo.text}</p>
            )
          }
          animation="bottom"
          key={keygen()}
          index={photo.index}
          setActive={setActive}
        />
      )
    }

    return (
      <MediaQuery
        query="(min-width: 992px)"
        values={{ deviceWidth: 1440, deviceHeight: 900, type: 'screen' }}
      >
        {matches => (
          <div
            className={
              matches === false && mobileViewer === true
                ? `${mobileViewerClass({ numberOfPhotos })} mobile-viewer`
                : 'desktop-viewer'
            }
          >
            <div className="gallery-container">
              <Gallery
                photos={photos}
                columns={
                  matches === true
                    ? columns.max
                    : mobileViewer === true
                    ? numberOfPhotos
                    : columns.min
                }
                ImageComponent={InteractiveImageX}
              />
            </div>
          </div>
        )}
      </MediaQuery>
    )
  }
}

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
export default InteractiveImages
